// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../../shared.module.css\"","lg":"992px","textContainer":"FeaturedProductsText_textContainer__1LsfE"};